import { Redirect as RedirectDOM } from 'react-router-dom';

import { useLink } from './useLink';

export function Redirect(props: { to: string }) {
	const to = useLink(props.to);

	return <RedirectDOM to={to} />;
}
